import { jsx as _jsx } from "react/jsx-runtime";
const ConfettiRectangle_01 = (props) => (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 8 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fill: "#555BE4", d: "M0 0h8v16H0z" }) })));
export default ConfettiRectangle_01;
//# sourceMappingURL=ConfettiRectangle_01.js.map